<div class="success-container">
  <div class="success-icon">
    <mat-icon>check_circle</mat-icon>
  </div>
  <h1 class="success-title">Verificação concluída com sucesso!</h1>
  <p class="success-message">Seus documentos foram processados. Você será redirecionado automaticamente em instantes...</p>

  <div class="loading-indicator">
    <mat-progress-spinner
      [diameter]="40"
      mode="indeterminate"
      color="primary">
    </mat-progress-spinner>
    <span class="countdown">{{ remainingSeconds }} segundos...</span>
  </div>
</div>
